import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { withStyles } from 'tss-react/mui';
import Container from '@mui/material/Container';
import CircleProgressButton from '../../buttons/CircleProgressButton';
import PasswordTextField from '../../form-elements/PasswordTextField';
import AuthDialogConstants from './AuthDialogConstants';

const styles = theme => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%'
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        textTransform: 'uppercase'
    },
    toggleButton: {
        textTransform: 'none',
        marginBottom: theme.spacing(1),
        display: 'block',
        margin: '0 auto'
    },
    formField: {
        marginBottom: theme.spacing(2),
        width: '100%'
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%'
    }
});

class LoginForm extends React.Component {
    state = {
        email: '',
        password: '',
        shouldValidate: false,
        emailError: false,
        passwordError: false,
    }

    render() {
        const { classes, setFormType, requesting } = this.props;
        const { email, password, emailError, passwordError } = this.state;

        return (
            <Container maxWidth='xs'>
                <div className={classes.paper}>
                    <Typography variant='h5' id='auth-dialog-label'>
                        Log in
                    </Typography>
                    <form className={classes.form} noValidate>
                        <TextField
                            variant='standard'
                            required
                            fullWidth
                            label='Email Address'
                            autoComplete='email'
                            value={email}
                            onChange={this.setEmail}
                            error={emailError}
                            className={classes.formField}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                    this.logInClick();
                                }
                            }}
                        />
                        <PasswordTextField
                            required
                            fullWidth
                            value={password}
                            onChange={this.setPassword}
                            error={passwordError}
                            autoComplete='current-password'
                            labelText='Password'
                            className={classes.formField}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                    this.logInClick();
                                }
                            }}
                        />
                        <CircleProgressButton
                            fullWidth
                            variant='contained'
                            color='primary'
                            className={classes.submit}
                            onClick={this.logInClick}
                            loading={requesting}
                        >
                            LOG IN
                        </CircleProgressButton>
                        <div className={classes.buttonsContainer}>
                            <Button
                                variant='text'
                                size='small'
                                onClick={() => setFormType(AuthDialogConstants.FORM_TYPE_SIGN_UP)}
                                className={classes.toggleButton}>
                                Don't have an account? Sign up
                            </Button>
                            <Button
                                variant='text'
                                size='small'
                                onClick={() => setFormType(AuthDialogConstants.FORM_TYPE_RESET)}
                                className={classes.toggleButton}>
                                Forgot password?
                            </Button>
                        </div>
                    </form>
                </div>
            </Container>
        );
    }

    logInClick = () => {
        const { login } = this.props;
        const { email, password } = this.state;

        this.setState({ shouldValidate: true });
        var valid = this.validate(this.state.email, this.state.password);
        if (valid) {
            login(email, password);
        }
    }

    setEmail = (event) => {
        const { password } = this.state;

        this.setState({ email: event.target.value })
        if (this.state.shouldValidate) {
            this.validate(event.target.value, password);
        }
    }

    setPassword = (event) => {
        const { email } = this.state;

        this.setState({ password: event.target.value })
        if (this.state.shouldValidate) {
            this.validate(email, event.target.value);
        }
    }

    validate = (email, password) => {
        var valid = true;

        if (email.length < 1) {
            this.setState({ emailError: true })
            valid = false;
        }
        else {
            this.setState({ emailError: false })
        }

        if (password.length < 1) {
            this.setState({ passwordError: true })
            valid = false;
        }
        else {
            this.setState({ passwordError: false })
        }

        return valid;
    }
}

export default withStyles(LoginForm, styles);